// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card-title {
  font-family: "Poppins" !important;
  font-weight: 500 !important;
  font-size: 0.55vw !important;
  line-height: 100% !important;
}

.card-subtitle {
  font-family: "Karla" !important;
  font-weight: 400 !important;
  font-size: 0.55vw !important;
  line-height: 0.55vw !important;
  letter-spacing: 0 !important;
}

.addBtn {
  width: 3vw; /* Prevents width from changing */
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  cursor: pointer !important;
  gap: .3vw;
}

.addBtnName {
  /* margin-top: 0.3vw !important; */
  font-family: "Poppins" !important;
  font-weight: 500 !important;
  font-size: 0.45vw !important;
  line-height: 100% !important;
}

.vertical-image {
  width: 100%;
  /* height: 255px; */
  object-fit: cover;
  display: block;
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/components/ui/cards/verticalCard/vertical.css"],"names":[],"mappings":"AAAA;EACE,iCAAiC;EACjC,2BAA2B;EAC3B,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,4BAA4B;EAC5B,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA;EACE,UAAU,EAAE,iCAAiC;EAC7C,wBAAwB;EACxB,iCAAiC;EACjC,8BAA8B;EAC9B,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,kCAAkC;EAClC,iCAAiC;EACjC,2BAA2B;EAC3B,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB","sourcesContent":[".card-title {\n  font-family: \"Poppins\" !important;\n  font-weight: 500 !important;\n  font-size: 0.55vw !important;\n  line-height: 100% !important;\n}\n\n.card-subtitle {\n  font-family: \"Karla\" !important;\n  font-weight: 400 !important;\n  font-size: 0.55vw !important;\n  line-height: 0.55vw !important;\n  letter-spacing: 0 !important;\n}\n\n.addBtn {\n  width: 3vw; /* Prevents width from changing */\n  display: flex !important;\n  flex-direction: column !important;\n  align-items: center !important;\n  cursor: pointer !important;\n  gap: .3vw;\n}\n\n.addBtnName {\n  /* margin-top: 0.3vw !important; */\n  font-family: \"Poppins\" !important;\n  font-weight: 500 !important;\n  font-size: 0.45vw !important;\n  line-height: 100% !important;\n}\n\n.vertical-image {\n  width: 100%;\n  /* height: 255px; */\n  object-fit: cover;\n  display: block;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
